if (!window.Eurus.loadedScript.has('v03-image-comparisons-metafield.js')) {
  window.Eurus.loadedScript.add('v03-image-comparisons-metafield.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
  Alpine.data('xImageComparisonMeta', (sectionId, layout) => ({
        carouselDragLocked: false,
        load(e) {
          const value = parseFloat(e?.target?.value || 0);
          console.debug('[before-after] load', sectionId, layout, value);
          if (layout == "horizontal") {
            this.$refs.image.style.setProperty('--compare_' + sectionId, value + '%');
          } else {
            this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, 100 - value + '%');
          }
        },
        blockCarouselDrag(event) {
          if (event?.pointerId && event.target?.setPointerCapture) {
            try {
              event.target.setPointerCapture(event.pointerId);
            } catch (error) {
              console.debug('[before-after] pointer capture error', error);
            }
          }
          this.toggleCarouselDrag(false);
        },
        allowCarouselDrag(event) {
          if (event?.pointerId && event.target?.hasPointerCapture && event.target.hasPointerCapture(event.pointerId) && event.target?.releasePointerCapture) {
            try {
              event.target.releasePointerCapture(event.pointerId);
            } catch (error) {
              console.debug('[before-after] pointer release error', error);
            }
          }
          this.toggleCarouselDrag(true);
        },
        toggleCarouselDrag(enable = true) {
          const shouldLock = !enable;
          if (this.carouselDragLocked === shouldLock) {
            return;
          }
          this.carouselDragLocked = shouldLock;

          const splideEl = document.getElementById('x-image-comparison-carousel-' + sectionId);
          if (splideEl && splideEl.splide) {
            try {
              splideEl.splide.options = { drag: !shouldLock };
            } catch (error) {
              console.debug('[before-after] splide drag toggle error', error);
            }
            splideEl.classList.toggle('before-after--drag-locked', shouldLock);
          }

          const swiperEl = document.getElementById('before-after-swiper-' + sectionId);
          if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.allowTouchMove = !shouldLock;
          }
        },
        resizeWindow(el) {
          addEventListener("resize", () => {
            this.setMinMaxInput(el, layout);
          });
        },
        disableScroll(el) {
          let isfocus = true;
          window.addEventListener('wheel', () => {
            if (isfocus) {
              el.blur();
              isfocus = false;
            }
          });
        },
        setMinMaxInput(el) {
          el.min = 0;
          el.max = 100;
        },
        animateValue(el) {
          const targetValue = parseFloat(el.value);
          let currentHorizontalValue = 100;
          let currentVerticalValue = 0; 
          const totalDuration = 1000;
          let startTime = null; 
        
          const easeInOutSlowEnd = (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
        
          const step = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const elapsedTime = timestamp - startTime;
            const progress = Math.min(elapsedTime / totalDuration, 1);
        
            const easedProgress = easeInOutSlowEnd(progress);
        
            if (layout === "horizontal") {
              currentHorizontalValue = 100 + (targetValue - 100) * easedProgress; 
              el.value = currentHorizontalValue.toFixed(2);
              this.$refs.image.style.setProperty('--compare_' + sectionId, currentHorizontalValue + '%');
        
              if (progress < 1) {
                requestAnimationFrame(step);
              } else {
                el.value = targetValue; 
                this.$refs.image.style.setProperty('--compare_' + sectionId, targetValue + '%');
              }
            } else {
              currentVerticalValue = 0 + (targetValue - 0) * easedProgress; 
              el.value = currentVerticalValue.toFixed(2);
              this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, currentVerticalValue + '%');
        
              if (progress < 1) {
                requestAnimationFrame(step);
              } else {
                el.value = targetValue;
                this.$refs.image.style.setProperty('--compare_vertical_' + sectionId, targetValue + '%');
              }
            }
          };
        
          requestAnimationFrame(step);
        }        
      }));
    });
  });
}